// src/components/utils/StripeRoot.js
import { memo, useMemo } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

const STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_CLIENT_KEY;

const stripePromise = STRIPE_PUBLISHABLE_KEY ? loadStripe(STRIPE_PUBLISHABLE_KEY) : null;

/**
 * StripeRoot — provides Stripe Elements context to its children. If the
 * publishable key is missing (e.g. local dev without `.env`), it renders
 * children without the Elements wrapper and logs a warning.
 */
const StripeRoot = ({ children, ...options }) => {
  const elementsOptions = useMemo(() => ({ locale: 'auto', ...options }), [options]);

  if (!stripePromise) {
    if (import.meta.env.MODE !== 'production') {
      console.warn(
        '[StripeRoot] Publishable key not found. Define VITE_STRIPE_CLIENT_KEY in .env to initialize Stripe.'
      );
    }
    return <>{children}</>;
  }

  return (
    <Elements stripe={stripePromise} options={elementsOptions}>
      {children}
    </Elements>
  );
};

export default memo(StripeRoot);
